const projects = [
  {
    id: "fetchpad",
    title: "FetchPad",
    icon: "fetchpad",
    href: "https://fetchpad.odinno.com/",
    external: true,
    description:
      "Test APIs quickly using GET & POST methods with parameters. Lightweight and developer-friendly.",
  },
  {
    id: "cvmaker",
    title: "CVmaker",
    icon: "cvmaker",
    href: "#cvmaker",
    external: false,
    description:
      "Create beautiful, professional resumes in minutes with an easy-to-use interface.",
  },
];

export default projects;
